module.exports = (__webpack_require__(53275))(672);